/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadTimData
 */
export interface LeadTimData {
    /**
     * 
     */
    execution_available: boolean;
    /**
     * 
     */
    execution_available_reason: LeadTimDataExecutionAvailableReasonEnum | null;
    /**
     * 
     */
    payor_id: string;
    /**
     * 
     */
    insurance_type: LeadTimDataInsuranceTypeEnum | null;
    /**
     * 
     */
    latest_execution_state: LeadTimDataLatestExecutionStateEnum | null;
}


/**
 * @export
 */
export const LeadTimDataExecutionAvailableReasonEnum = {
    LeadAnalysisInProgress: 'lead_analysis_in_progress',
    NoPrimaryCommercialInsurance: 'no_primary_commercial_insurance',
    NoContractStored: 'no_contract_stored',
    PayorNotSupported: 'payor_not_supported',
    QuotaExceeded: 'quota_exceeded',
} as const;
export type LeadTimDataExecutionAvailableReasonEnum = typeof LeadTimDataExecutionAvailableReasonEnum[keyof typeof LeadTimDataExecutionAvailableReasonEnum];

/**
 * @export
 */
export const LeadTimDataInsuranceTypeEnum = {
    Commercial: 'Commercial',
    ManagedMedicare: 'Managed Medicare',
    ManagedMedicaid: 'Managed Medicaid',
    Medicare: 'Medicare',
    Medicaid: 'Medicaid',
    Other: 'Other',
    PrivatePay: 'Private Pay',
} as const;
export type LeadTimDataInsuranceTypeEnum = typeof LeadTimDataInsuranceTypeEnum[keyof typeof LeadTimDataInsuranceTypeEnum];

/**
 * @export
 */
export const LeadTimDataLatestExecutionStateEnum = {
    Created: 'created',
    InProgress: 'in_progress',
    Finished: 'finished',
} as const;
export type LeadTimDataLatestExecutionStateEnum = typeof LeadTimDataLatestExecutionStateEnum[keyof typeof LeadTimDataLatestExecutionStateEnum];


/**
 * Check if a given object implements the LeadTimData interface.
 */
export function instanceOfLeadTimData(value: object): value is LeadTimData {
    if (!('execution_available' in value) || value['execution_available'] === undefined) return false;
    if (!('execution_available_reason' in value) || value['execution_available_reason'] === undefined) return false;
    if (!('payor_id' in value) || value['payor_id'] === undefined) return false;
    if (!('insurance_type' in value) || value['insurance_type'] === undefined) return false;
    if (!('latest_execution_state' in value) || value['latest_execution_state'] === undefined) return false;
    return true;
}

export function LeadTimDataFromJSON(json: any): LeadTimData {
    return LeadTimDataFromJSONTyped(json, false);
}

export function LeadTimDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadTimData {
    if (json == null) {
        return json;
    }
    return {
        
        'execution_available': json['execution_available'],
        'execution_available_reason': json['execution_available_reason'],
        'payor_id': json['payor_id'],
        'insurance_type': json['insurance_type'],
        'latest_execution_state': json['latest_execution_state'],
    };
}

export function LeadTimDataToJSON(json: any): LeadTimData {
    return LeadTimDataToJSONTyped(json, false);
}

export function LeadTimDataToJSONTyped(value?: LeadTimData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'execution_available': value['execution_available'],
        'execution_available_reason': value['execution_available_reason'],
        'payor_id': value['payor_id'],
        'insurance_type': value['insurance_type'],
        'latest_execution_state': value['latest_execution_state'],
    };
}

